var map = {
	"./icons/logout.svg": 1237,
	"./icons/user.svg": 6602,
	"./logo.png": 5549,
	"./logo_blue.svg": 2930,
	"./logo_small.png": 8017,
	"./logo_small.svg": 4903,
	"./logo_small_blue.svg": 2554,
	"./others/app_store_link.png": 3800,
	"./others/app_store_qr.png": 3205,
	"./others/play_store_link.png": 6075,
	"./others/play_store_qr.png": 7442,
	"./placeholder.png": 9829,
	"./remarket-only-logo.svg": 7644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;